module.exports = __webpack_public_path__ + "img/cancelled_pickup.134d7707.svg";